import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PAYMENT_ADD_PAYEE } from 'constants/shared/routes';
import ButtonContainer from 'components/shared/generic/buttonContainer/presentational/ButtonContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import PayeeInfiniteScroll from '../presentational/PayeeInfiniteScroll';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import useTranslate from 'lib/languages/useTranslate';
import { trackCustomerIOEvent } from 'utils/customerIO';
import { useGetPayeesQuery } from 'lib/services/payee';
import { CustomerIOEvent } from 'lib/type/enums';
import { setSelectedPayee } from 'lib/slices';

const PayeeInfiniteScrollContainer = ({ backRoute, nextRoute, flow }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data: payees, isFetching, error } = useGetPayeesQuery();
    const translate = useTranslate('managePayees');
    const handleAddNewPayee = () => {
        navigate(PAYMENT_ADD_PAYEE, { state: { backRoute: backRoute } });
    };

    const handleSelectedPayee = payee => {
        dispatch(setSelectedPayee(payee));
        navigate(nextRoute);
        trackCustomerIOEvent(CustomerIOEvent.SELECTED_PAYEE, {
            payeeName: payee.payeeName,
            sortCode: payee.sortCode,
            flow,
        });
    };

    return (
        <>
            <DataCheck
                noDataMessage={translate('noDataMessage')}
                data={payees}
                isLoading={isFetching}
                error={error}
            >
                <PayeeInfiniteScroll
                    data={payees}
                    onPayeeClick={handleSelectedPayee}
                />
            </DataCheck>
            <ButtonContainer>
                <Button onClick={handleAddNewPayee} className="center">
                    {translate('addNewPayee')}
                </Button>
            </ButtonContainer>
        </>
    );
};

export default PayeeInfiniteScrollContainer;
